export const sharedThemeOptions = {
  BackstageHeader: {
    styleOverrides: {
      header: {
        boxShadow: 'none',
      },
    },
  },
  MuiTab: {
    styleOverrides: {
      root: {
        textTransform: 'none',
        letterSpacing: 0,
        minWidth: '72px !important',
        variants: [],
      },
    },
  },
  BackstageHeaderTabs: {
    styleOverrides: {
      defaultTab: {
        textTransform: 'capitalize',
        padding: 'var(--bui-space-2) var(--bui-space-3)',
        fontSize: 'var(--bui-font-size-3)',
        variants: [],
      },
    },
  },
  BackstageSelectInputBase: {
    styleOverrides: {
      input: {
        border: `1px solid var(--bui-border-1)`,
      },
    },
  },
  BackstageSidebar: {
    styleOverrides: {
      drawer: {
        borderRight: `1px solid var(--bui-border-1)`,
        '& hr': {
          background: 'rgba(26, 26, 26, 0.08)',
        },
      },
    },
  },
  BackstageSidebarItem: {
    styleOverrides: {
      root: {
        borderLeft: 'none',
      },
      selected: {
        background: 'var(--bui-bg-neutral-2)',
      },
    },
  },
};
